import { Component, forwardRef, inject, input, OnInit, signal } from '@angular/core';
import {Menu} from '../types/left-menu.types';
import {leftMenuConfig} from '../configs/left-menu-config';
import {SidebarService} from '../../../services/sidebar.service';
import {LeftMenuService} from "../services/left-menu.service";
import {
  DefaultLeftMenuItemComponent
} from "../left-menu-items/default-left-menu-item/default-left-menu-item.component";
import {
  SubmenuLeftMenuItemComponent
} from "../left-menu-items/submenu-left-menu-item/submenu-left-menu-item.component";

@Component({
  selector: 'app-left-menu-list',
  standalone: true,
  imports: [
    DefaultLeftMenuItemComponent,
    forwardRef(() => SubmenuLeftMenuItemComponent)
  ],
  templateUrl: './left-menu-list.component.html',
  styleUrl: './left-menu-list.component.scss'
})
export class LeftMenuListComponent implements OnInit {
  private sidebarService: SidebarService = inject(SidebarService);

  menuList = input<Array<Menu>>(leftMenuConfig);
  isSubmenu = input<boolean>(false);
  parentMenuId = input<string | null>(null);

  private leftMenuService: LeftMenuService = inject(LeftMenuService);

  public isMenuSmall = signal<boolean>(false);

  public ngOnInit() {
    this.isMenuSmall.set(this.sidebarService.isSidebarFolded)
  }

  public isMenuAvailableToCurrentUser(menu: Menu): boolean {
    return this.leftMenuService.isMenuAvailableToCurrentUser(menu);
  }
}
